import {getNavigationJson} from "../repositories/Navigation/request";
import React, {useCallback, useEffect, useState} from "react";
import {ContentType, NavigationItem} from "../repositories/Navigation/types";
import Nav from "react-bootstrap/Nav";
import {NavDropdown} from "react-bootstrap";
import {NavLink} from "react-router-dom";
import "./MegaMenu.scss";

export type TDynamicNav = {
    id: string;
    onSelect?: () => {};
    itemGroup?: NavigationItem[];
    locale?: string;
};

export const DynamicNavList = (props: TDynamicNav) => {
    const {id, itemGroup, locale, onSelect} = props;
    
    const fetchData = useCallback(async () => {
        const dataFetched = await getNavigationJson(id, locale ?? "en");

        setData(dataFetched);
    }, [id,locale])

    const [data, setData] = useState<NavigationItem[]>(itemGroup ?? []);

    useEffect(() => {
        
        if (!data.length)
            fetchData().catch(console.error);
    }, [fetchData]);

    useEffect(() => {
            fetchData().catch(console.error);
    }, [locale]);

    const gslugPrefix = props.locale ? `/${locale}/` :"/";
    return (
        <>
            {data && data.map((navItem: NavigationItem, index) => {
                let slugPrefix = navItem.slug?.includes( gslugPrefix) ? "/" : gslugPrefix;
           
                if(slugPrefix?.endsWith("//"))
                    slugPrefix = props.locale ?? "/"

                const key =index +  (props.locale ?? "");                     

                switch (navItem.__typename) {
                    case ContentType.ExternalLink:
                        return (
                            <a
                                key={key}
                                href={navItem.url ?? ""}
                                className="nav-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                data-test="full link"
                            >
                                {navItem.title}
                            </a>
                        );
                  
                    case ContentType.PdfAndVideo:
                        return (
                            <NavDropdown title={navItem.title ?? "_"} id={`basic-nav-dropdown-${navItem.id}`}>
                                <button type="button" className="navigation-back" onClick={(e) => {e.preventDefault(); e.currentTarget.parentElement?.parentElement?.click()}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 320 512" aria-hidden="true"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>
                                    Back
                                </button>

                                <Nav.Link onClick={onSelect} as={NavLink} key={key+"-video"} to={slugPrefix + (navItem.video?.slug ?? "")}>
                                    {"Video format"}
                                </Nav.Link>
                                
                                <a
                                    key={key+"-pdf"}
                                    href={navItem.pdf?.url ?? ""}
                                    className="nav-link"
                                    data-test="full link">
                                    {"PDF format"}
                                </a> 
                            </NavDropdown>
                        );
                        
                    case ContentType.NavigationGroup:
                        return (
                            <NavDropdown title={navItem.title ?? "_"} id={`basic-nav-dropdown-${navItem.id}`}>
                                <button type="button" className="navigation-back" onClick={(e) => {e.preventDefault(); e.currentTarget.parentElement?.parentElement?.click()}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 320 512" aria-hidden="true"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>
                                    Back
                                </button>

                                <DynamicNavList key={key} onSelect={onSelect} itemGroup={(navItem).navigationItem} locale={props.locale} id={navItem?.id ?? "123"}></DynamicNavList>
                            </NavDropdown>
                        );
                    case ContentType.VotingPage:
                        return (
                            <Nav.Link onClick={onSelect} as={NavLink} key={key} to={slugPrefix}>
                                {navItem.title ?? "error"}
                            </Nav.Link>
                        );
                    default:
                    case ContentType.SpecialPageRecord:
                    case ContentType.RegistrationPage:                    
                    case ContentType.VotingResult:
                    case ContentType.VideoPage:
                    case ContentType.BlogPost:
                    case ContentType.VideoWithPdfs:
                        return (
                            <Nav.Link onClick={onSelect} as={NavLink} key={key} to={slugPrefix + (navItem.slug ?? "")}>
                                {navItem.title ?? "error"}
                            </Nav.Link>
                        );
                    
                    
                }
            })}
        </>
    );
};  
